class Card {
    constructor(suit, value) {
        this.suit = suit; // 'oros', 'copas', 'espadas', 'bastos'
        this.value = value; // 1-7, 10-12
        this.isFaceUp = false; // Default to face down
        // Baciga wildcards (7 oros / 7 copas) get bound to a value once declared.
        // Declared here so it's a first-class property instead of an ad-hoc one
        // added later via Object.assign. Normal mutation path is
        // DealManager.updateCardData(); save/restore flows are the one
        // intentional exception, since they reconstruct already-validated state.
        this.assignedValue = undefined;
    }

    flip() {
        this.isFaceUp = !this.isFaceUp;
    }

    get imagePath() {
        // Assuming assets are stored in a standard way, e.g., assets/cards/oros_1.png
        // We might need to adjust this based on actual asset structure
        return `assets/cards/${this.suit}_${this.value}.png`;
    }

    toString() {
        return `${this.value} de ${this.suit}`;
    }
}

export default Card;
